import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getdetailsPdfDownloadSales,
  getEcommerceSalesDetailsList,
} from "../../services/SalesServices";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { tConstStatic } from "../../utils/constantsTranslator";

const SalesDetails = () => {
  const { uuid } = useParams();
  const { t } = useTranslation();

  const navigate = useNavigate();
  const state = useLocation();

  const [salesDetails, setSalesDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (uuid) {
      let data = {
        id: uuid,
      };

      getEcommerceSalesDetailsList(data)
        .then((response) => {
          setSalesDetails(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [uuid]);

  const handleSalesDownload = (e, salesDetails) => {
    e.preventDefault();

    setIsLoading(true); // Show the loader

    let data = {
      id: uuid,
    };

    getdetailsPdfDownloadSales(data)
      .then((response) => {
        setIsLoading(false); // Hide the loader after download is complete
        // toast.success(response.data.message);

        const downloadUrl = response.data.data.url;

        if (downloadUrl) {
          window.open(downloadUrl, "_blank"); // Opens in a new tab
          setIsLoading(false);
        } else {
          toast.error(t("no_download_url_provided"));
        }
      })
      .catch((err) => {
        setIsLoading(false); // Hide the loader if there's an error
        toast.error(Utils.getErrorMessage(err));
      });
  };

  return (
    <div>
      <div>
        <div>
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="card fuelCard">
                <div className="cardHeader card-header card-header-custom">
                  <div className="row align-items-center">
                    {/* LEFT SIDE */}
                    <div className="col-sm-6">
                      <p className="mb-0 fw-bold">Sales Details</p>
                    </div>

                    {/* RIGHT SIDE */}
                    <div className="col-sm-6 d-flex justify-content-end gap-2">
                      <button
                        onClick={handleSalesDownload}
                        type="button"
                        className="btn btn-primary"
                      >
                        PDF
                        {isLoading ? (
                          <span className="spinner-border spinner-border-sm ms-2"></span>
                        ) : (
                          <i className="bi bi-file-earmark-pdf-fill ms-2"></i>
                        )}
                      </button>

                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                          state?.state?.part_management_type
                            ? navigate(`/vehicle/${state?.state?.uuid}`)
                            : navigate("/sales");
                        }}
                      >
                        <i className="bi bi-arrow-left"></i> {t("back")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

              <>
                <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card fuelCard">
                          <div className="cardHeader card-header card-header-custom">
                            <p>Sales Details</p>
                          </div>
                          <div className="card-body card-body-custom">
                            <div className="row justify-content-start">
                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b>Invoice Number:</b>{" "}
                                  <address>
                                    {salesDetails.invoice_number || "-"}
                                  </address>
                                </div>
                              </div>

                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b> Order Status Name:</b>{" "}
                                  <address>
                                    {tConstStatic(salesDetails.order_status_name) || "-"}
                                  </address>
                                </div>
                              </div>

                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b> Created Date:</b>{" "}
                                  <address>
                                    {salesDetails?.created_at
                                      ? moment(salesDetails?.created_at).format(
                                          "DD/MM/YYYY",
                                        )
                                      : "-"}
                                  </address>
                                </div>
                              </div>

                              {salesDetails?.proudct_list && (
                                <>
                                  <div className="card-custom-heading">
                                    <p>Product List</p>
                                  </div>
                                  <div className="card-body card-body-custom">
                                    <div className="row justify-content-start">
                                      <>
                                        <div className="card-body card-body-custom">
                                          <div className="vehicleThBg table-responsive">
                                            <table className="table table-bordered rounded-table table table-striped table-hover">
                                              <thead>
                                                <tr>
                                                  <th className="col-form-label ml-2 Label-my form-label form-label"></th>
                                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                                    Name{" "}
                                                  </th>
                                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                                    Quantity{" "}
                                                  </th>
                                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                                    Price without vat
                                                  </th>

                                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                                    Tax vat
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {salesDetails?.proudct_list?.map(
                                                  (items) => {
                                                    return (
                                                      <>
                                                        <tr>
                                                          <td>
                                                            <div
                                                              className="edit-btn cursor-pointer"
                                                              onClick={() =>
                                                                navigate(
                                                                  `/part/details/inven/${items.product_id}`,
                                                                )
                                                              }
                                                            >
                                                              <i
                                                                className="bi bi-eye"
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              ></i>{" "}
                                                            </div>
                                                          </td>
                                                          <td>
                                                            {
                                                              items?.product_name
                                                            }
                                                          </td>
                                                          <td>
                                                            {items?.quantity}
                                                          </td>
                                                          <td>
                                                            {
                                                              items?.price_without_vat
                                                            }
                                                          </td>
                                                          <td>
                                                            {items?.tax_vat}
                                                          </td>
                                                        </tr>
                                                      </>
                                                    );
                                                  },
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </>
                                    </div>
                                  </div>
                                </>
                              )}

                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b> Number products:</b>{" "}
                                  <address>{salesDetails.num_products || "0"}</address>
                                </div>
                              </div>

                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b> Tax Vat Other Parcel:</b>{" "}
                                  <address>
                                    € {salesDetails?.tax_vat_other_parcel || "0"}
                                  </address>
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b> Tax Vat Packaging:</b>{" "}
                                  <address>
                                    € {salesDetails?.tax_vat_packaging || "0"}
                                  </address>
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b> Tax Vat Product:</b>{" "}
                                  <address>
                                    € {salesDetails?.tax_vat_products || ""}
                                  </address>
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b>Tax Vat Shipping:</b>{" "}
                                  <address>
                                    € {salesDetails?.tax_vat_shipping || "-"}
                                  </address>
                                </div>
                              </div>

                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b> Total value other parcel:</b>{" "}
                                  <address>
                                    € {salesDetails.total_value_other_parcel || "-"}
                                  </address>
                                </div>
                              </div>

                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b> Total value packaging:</b>{" "}
                                  <address>
                                    € {salesDetails.total_value_packaging || "-"}
                                  </address>
                                </div>
                              </div>

                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b> Total value products:</b>{" "}
                                  <address>
                                    € {salesDetails.total_value_products || "-"}
                                  </address>
                                </div>
                              </div>

                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b> total value shipping:</b>{" "}
                                  <address>
                                    € {salesDetails.total_value_shipping || "-"}
                                  </address>
                                </div>
                              </div>

                              {salesDetails?.client_list && (
                                <>
                                  <div className="card-custom-heading">
                                    <p>Client List</p>
                                  </div>
                                  <div className="card-body card-body-custom">
                                    <div className="row justify-content-start">
                                      <>
                                        <div className="card-body card-body-custom">
                                          <div className="vehicleThBg table-responsive">
                                            <table className="table table-bordered rounded-table table table-striped table-hover">
                                              <thead>
                                                <tr>
                                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                                    Name{" "}
                                                  </th>
                                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                                    Shipping Address
                                                  </th>

                                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                                    Country Code{" "}
                                                  </th>

                                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                                    Postal Code{" "}
                                                  </th>

                                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                                    City{" "}
                                                  </th>

                                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                                    VAT Number{" "}
                                                  </th>

                                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                                    Country code VAT number{" "}
                                                  </th>

                                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                                    Phone{" "}
                                                  </th>

                                                  <th className="col-form-label ml-2 Label-my form-label form-label">
                                                    Email{" "}
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {salesDetails?.client_list?.map(
                                                  (items) => {
                                                    return (
                                                      <>
                                                        <tr>
                                                          <td>{items?.name}</td>
                                                          <td>
                                                            {
                                                              items?.shipping_address
                                                            }
                                                          </td>
                                                          <td>
                                                            {
                                                              items?.country_code
                                                            }
                                                          </td>
                                                          <td>
                                                            {items?.postal_code}
                                                          </td>
                                                          <td>{items?.city}</td>
                                                          <td>
                                                            {items?.vat_number}
                                                          </td>
                                                          <td>
                                                            {
                                                              items?.country_code_vat_number
                                                            }
                                                          </td>
                                                          <td>
                                                            {items?.phone}
                                                          </td>
                                                          <td>
                                                            {items?.email}
                                                          </td>
                                                        </tr>
                                                      </>
                                                    );
                                                  },
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </>
                                    </div>
                                  </div>
                                </>
                              )}

                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b>Shipping Company :</b>{" "}
                                  <address>
                                    {salesDetails?.shipping_company || "-"}
                                  </address>
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b>Shipping Label</b>{" "}
                                  <address>
                                    <a
                                      href={salesDetails.shipping_label}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <i className="bi bi-file-earmark-pdf"></i>{" "}
                                    </a>
                                  </address>
                                </div>
                              </div>
                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b>Shipping Tracking Code:</b>{" "}
                                  <address>
                                    {salesDetails?.shipping_tracking_code || "-"}
                                  </address>
                                </div>
                              </div>

                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b> Notes Sale:</b>{" "}
                                  <address>{salesDetails.notes_sale || "-"}</address>
                                </div>
                              </div>

                              <div className="col-sm-6">
                                <div className="invoice-col">
                                  <b> Maximum sale alert date:</b>{" "}
                                  <address>
                                    {salesDetails?.maximum_sale_alert_date
                                      ? moment(
                                          salesDetails?.maximum_sale_alert_date,
                                        ).format("DD/MM/YYYY")
                                      : "-"}
                                  </address>
                                </div>
                              </div>
                            </div>
                          </div>

                          {salesDetails?.bill_list && (
                            <>
                              <div className="card-custom-heading">
                                <p>Bill List</p>
                              </div>
                              <div className="card-body card-body-custom">
                                <div className="row justify-content-start">
                                  <>
                                    <div className="card-body card-body-custom">
                                      <div className="vehicleThBg table-responsive">
                                        <table className="table table-bordered rounded-table table table-striped table-hover">
                                          <thead>
                                            <tr>
                                              <th className="col-form-label ml-2 Label-my form-label form-label">
                                                Refund Status{" "}
                                              </th>
                                              <th className="col-form-label ml-2 Label-my form-label form-label">
                                                Provider Type Refund{" "}
                                              </th>
                                              <th className="col-form-label ml-2 Label-my form-label form-label">
                                                Provider Refund Value{" "}
                                              </th>
                                              <th className="col-form-label ml-2 Label-my form-label form-label">
                                                Seller Type Refund{" "}
                                              </th>
                                              <th className="col-form-label ml-2 Label-my form-label form-label">
                                                Seller Refund Value{" "}
                                              </th>

                                              <th className="col-form-label ml-2 Label-my form-label form-label">
                                                Refund Accept Full{" "}
                                              </th>
                                              <th className="col-form-label ml-2 Label-my form-label form-label">
                                                Refund Accept Partial
                                              </th>

                                              <th className="col-form-label ml-2 Label-my form-label form-label">
                                                Refund reason{" "}
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {salesDetails?.bill_list?.map((items) => {
                                              return (
                                                <>
                                                  <tr>
                                                    <td>
                                                      {items?.refund_reason ||
                                                        "-"}
                                                    </td>{" "}
                                                    <td>
                                                      {items?.refund_reason ||
                                                        "-"}
                                                    </td>{" "}
                                                    <td>
                                                      {items?.refund_reason ||
                                                        "-"}
                                                    </td>{" "}
                                                    <td>
                                                      {items?.refund_reason ||
                                                        "-"}
                                                    </td>{" "}
                                                    <td>
                                                      {items?.refund_reason ||
                                                        "-"}
                                                    </td>{" "}
                                                    <td>
                                                      {items?.refund_accept_full ===
                                                      true
                                                        ? "Yes"
                                                        : "No"}
                                                    </td>
                                                    <td>
                                                      {items?.refund_accept_partial ===
                                                      true
                                                        ? "Yes"
                                                        : "No"}
                                                    </td>
                                                    <td>
                                                      {items?.refund_reason ||
                                                        "-"}
                                                    </td>
                                                  </tr>
                                                </>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </>
                                </div>
                              </div>
                            </>
                          )}

                          {salesDetails?.image_list?.length > 0 && (
                            <>
                              <div className="card-custom-heading">
                                <p>Image List</p>
                              </div>

                              <div className="card-body card-body-custom">
                                <PhotoProvider>
                                  <div className="row justify-content-start">
                                    {salesDetails.image_list.map((image, index) => (
                                      <div className="col-sm-3" key={index}>
                                        <div className="column-img">
                                          {image?.image_url ? (
                                            <PhotoView src={image.image_url}>
                                              <img
                                                src={image.image_url}
                                                alt="vehicle"
                                                style={{
                                                  width: "60%",
                                                  cursor: "pointer",
                                                }}
                                              />
                                            </PhotoView>
                                          ) : (
                                            <p>No image found</p>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </PhotoProvider>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </>

        </div>
      </div>
    </div>
  );
};

export default SalesDetails;
